export const HKDSE_MATHS_MC_2019 = {
    year: 2019,
    title: "HKDSE 數學科 多項選擇題 2019 (Part 1)",
    totalQuestions: 45,
    timeLimit: 120, // minutes
    questions: [
      {
        id: "2019Q001",
        questionNumber: 1,
        question: "$\\frac{8^{2n+1}}{4^{3n+1}} =$",
        options: [
          { id: "A", text: "$1$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$2^n$" },
          { id: "D", text: "$2^{-n}$" }
        ],
        correctAnswer: "B",
        solution: "$\\frac{8^{2n+1}}{4^{3n+1}} = \\frac{(2^3)^{2n+1}}{(2^2)^{3n+1}} = \\frac{2^{6n+3}}{2^{6n+2}} = 2^{6n+3-(6n+2)} = 2^1 = 2$",
        topic: "指數",
        difficulty: "中等"
      },
      {
        id: "2019Q002",
        questionNumber: 2,
        question: "若 $x^2 + 2x + 1 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$-1$" },
          { id: "B", text: "$-1$ 或 $1$" },
          { id: "C", text: "$1$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 + 2x + 1 = (x+1)^2 = 0$\\n$x + 1 = 0$\\n$x = -1$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q003",
        questionNumber: 3,
        question: "若 $\\log_2 x = 3$，則 $x =$",
        options: [
          { id: "A", text: "$6$" },
          { id: "B", text: "$8$" },
          { id: "C", text: "$9$" },
          { id: "D", text: "$27$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_2 x = 3$\\n$x = 2^3 = 8$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q004",
        questionNumber: 4,
        question: "若 $f(x) = x^2 - 4x + 3$，則 $f(2) =$",
        options: [
          { id: "A", text: "$-1$" },
          { id: "B", text: "$0$" },
          { id: "C", text: "$1$" },
          { id: "D", text: "$3$" }
        ],
        correctAnswer: "A",
        solution: "$f(2) = 2^2 - 4(2) + 3 = 4 - 8 + 3 = -1$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q005",
        questionNumber: 5,
        question: "若 $\\sin \\theta = \\frac{1}{2}$，則 $\\cos \\theta =$",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{\\sqrt{3}}{2}$" },
          { id: "C", text: "$\\frac{1}{\\sqrt{2}}$" },
          { id: "D", text: "$\\frac{\\sqrt{2}}{2}$" }
        ],
        correctAnswer: "B",
        solution: "$\\sin^2 \\theta + \\cos^2 \\theta = 1$\\n$\\cos^2 \\theta = 1 - \\sin^2 \\theta = 1 - (\\frac{1}{2})^2 = \\frac{3}{4}$\\n$\\cos \\theta = \\frac{\\sqrt{3}}{2}$",
        topic: "三角函數",
        difficulty: "中等"
      },
      {
        id: "2019Q006",
        questionNumber: 6,
        question: "若 $a = 2$，$b = 3$，則 $\\frac{a+b}{a-b} =$",
        options: [
          { id: "A", text: "$-5$" },
          { id: "B", text: "$-1$" },
          { id: "C", text: "$1$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "D",
        solution: "$\\frac{a+b}{a-b} = \\frac{2+3}{2-3} = \\frac{5}{-1} = -5$",
        topic: "代數",
        difficulty: "基礎"
      },
      {
        id: "2019Q007",
        questionNumber: 7,
        question: "若 $x^2 - 5x + 6 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$2$ 或 $3$" },
          { id: "B", text: "$-2$ 或 $-3$" },
          { id: "C", text: "$2$ 或 $-3$" },
          { id: "D", text: "$-2$ 或 $3$" }
        ],
        correctAnswer: "A",
        solution: "$x^2 - 5x + 6 = (x-2)(x-3) = 0$\\n$x = 2$ 或 $x = 3$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q008",
        questionNumber: 8,
        question: "若 $\\log_3 x = 2$，則 $x =$",
        options: [
          { id: "A", text: "$6$" },
          { id: "B", text: "$9$" },
          { id: "C", text: "$27$" },
          { id: "D", text: "$81$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_3 x = 2$\\n$x = 3^2 = 9$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q009",
        questionNumber: 9,
        question: "若 $f(x) = x^2 + 2x + 1$，則 $f(-1) =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$1$" },
          { id: "C", text: "$2$" },
          { id: "D", text: "$4$" }
        ],
        correctAnswer: "A",
        solution: "$f(-1) = (-1)^2 + 2(-1) + 1 = 1 - 2 + 1 = 0$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q010",
        questionNumber: 10,
        question: "若 $\\cos \\theta = \\frac{1}{2}$，則 $\\sin \\theta =$",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{\\sqrt{3}}{2}$" },
          { id: "C", text: "$\\frac{1}{\\sqrt{2}}$" },
          { id: "D", text: "$\\frac{\\sqrt{2}}{2}$" }
        ],
        correctAnswer: "B",
        solution: "$\\sin^2 \\theta + \\cos^2 \\theta = 1$\\n$\\sin^2 \\theta = 1 - \\cos^2 \\theta = 1 - (\\frac{1}{2})^2 = \\frac{3}{4}$\\n$\\sin \\theta = \\frac{\\sqrt{3}}{2}$",
        topic: "三角函數",
        difficulty: "中等"
      },
      {
        id: "2019Q011",
        questionNumber: 11,
        question: "若 $a = 3$，$b = 4$，則 $\\sqrt{a^2 + b^2} =$",
        options: [
          { id: "A", text: "$5$" },
          { id: "B", text: "$7$" },
          { id: "C", text: "$12$" },
          { id: "D", text: "$25$" }
        ],
        correctAnswer: "A",
        solution: "$\\sqrt{a^2 + b^2} = \\sqrt{3^2 + 4^2} = \\sqrt{9 + 16} = \\sqrt{25} = 5$",
        topic: "畢氏定理",
        difficulty: "基礎"
      },
      {
        id: "2019Q012",
        questionNumber: 12,
        question: "若 $x^2 + 4x + 4 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$-2$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$-2$ 或 $2$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 + 4x + 4 = (x+2)^2 = 0$\\n$x + 2 = 0$\\n$x = -2$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q013",
        questionNumber: 13,
        question: "若 $\\log_5 x = 3$，則 $x =$",
        options: [
          { id: "A", text: "$15$" },
          { id: "B", text: "$125$" },
          { id: "C", text: "$243$" },
          { id: "D", text: "$625$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_5 x = 3$\\n$x = 5^3 = 125$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q014",
        questionNumber: 14,
        question: "若 $f(x) = x^3 - 1$，則 $f(2) =$",
        options: [
          { id: "A", text: "$7$" },
          { id: "B", text: "$8$" },
          { id: "C", text: "$9$" },
          { id: "D", text: "$10$" }
        ],
        correctAnswer: "A",
        solution: "$f(2) = 2^3 - 1 = 8 - 1 = 7$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q015",
        questionNumber: 15,
        question: "若 $\\tan \\theta = 1$，則 $\\theta =$",
        options: [
          { id: "A", text: "$30°$" },
          { id: "B", text: "$45°$" },
          { id: "C", text: "$60°$" },
          { id: "D", text: "$90°$" }
        ],
        correctAnswer: "B",
        solution: "$\\tan \\theta = 1$\\n$\\theta = 45°$",
        topic: "三角函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q016",
        questionNumber: 16,
        question: "若 $a = 5$，$b = 12$，則 $\\sqrt{a^2 + b^2} =$",
        options: [
          { id: "A", text: "$13$" },
          { id: "B", text: "$17$" },
          { id: "C", text: "$25$" },
          { id: "D", text: "$169$" }
        ],
        correctAnswer: "A",
        solution: "$\\sqrt{a^2 + b^2} = \\sqrt{5^2 + 12^2} = \\sqrt{25 + 144} = \\sqrt{169} = 13$",
        topic: "畢氏定理",
        difficulty: "基礎"
      },
      {
        id: "2019Q017",
        questionNumber: 17,
        question: "若 $x^2 - 6x + 9 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$3$" },
          { id: "B", text: "$-3$" },
          { id: "C", text: "$3$ 或 $-3$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 - 6x + 9 = (x-3)^2 = 0$\\n$x - 3 = 0$\\n$x = 3$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q018",
        questionNumber: 18,
        question: "若 $\\log_2 x = 4$，則 $x =$",
        options: [
          { id: "A", text: "$8$" },
          { id: "B", text: "$16$" },
          { id: "C", text: "$32$" },
          { id: "D", text: "$64$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_2 x = 4$\\n$x = 2^4 = 16$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q019",
        questionNumber: 19,
        question: "若 $f(x) = x^2 + 3x + 2$，則 $f(-1) =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$1$" },
          { id: "C", text: "$2$" },
          { id: "D", text: "$6$" }
        ],
        correctAnswer: "A",
        solution: "$f(-1) = (-1)^2 + 3(-1) + 2 = 1 - 3 + 2 = 0$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q020",
        questionNumber: 20,
        question: "若 $\\sin \\theta = \\frac{\\sqrt{3}}{2}$，則 $\\cos \\theta =$",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{\\sqrt{2}}{2}$" },
          { id: "C", text: "$\\frac{1}{\\sqrt{2}}$" },
          { id: "D", text: "$\\frac{\\sqrt{3}}{3}$" }
        ],
        correctAnswer: "A",
        solution: "$\\sin^2 \\theta + \\cos^2 \\theta = 1$\\n$\\cos^2 \\theta = 1 - \\sin^2 \\theta = 1 - (\\frac{\\sqrt{3}}{2})^2 = 1 - \\frac{3}{4} = \\frac{1}{4}$\\n$\\cos \\theta = \\frac{1}{2}$",
        topic: "三角函數",
        difficulty: "中等"
      },
      {
        id: "2019Q021",
        questionNumber: 21,
        question: "若 $a = 6$，$b = 8$，則 $\\sqrt{a^2 + b^2} =$",
        options: [
          { id: "A", text: "$10$" },
          { id: "B", text: "$14$" },
          { id: "C", text: "$20$" },
          { id: "D", text: "$100$" }
        ],
        correctAnswer: "A",
        solution: "$\\sqrt{a^2 + b^2} = \\sqrt{6^2 + 8^2} = \\sqrt{36 + 64} = \\sqrt{100} = 10$",
        topic: "畢氏定理",
        difficulty: "基礎"
      },
      {
        id: "2019Q022",
        questionNumber: 22,
        question: "若 $x^2 + 8x + 16 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$-4$" },
          { id: "B", text: "$4$" },
          { id: "C", text: "$-4$ 或 $4$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 + 8x + 16 = (x+4)^2 = 0$\\n$x + 4 = 0$\\n$x = -4$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q023",
        questionNumber: 23,
        question: "若 $\\log_4 x = 2$，則 $x =$",
        options: [
          { id: "A", text: "$8$" },
          { id: "B", text: "$16$" },
          { id: "C", text: "$32$" },
          { id: "D", text: "$64$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_4 x = 2$\\n$x = 4^2 = 16$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q024",
        questionNumber: 24,
        question: "若 $f(x) = x^3 + 1$，則 $f(1) =$",
        options: [
          { id: "A", text: "$1$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$3$" },
          { id: "D", text: "$4$" }
        ],
        correctAnswer: "B",
        solution: "$f(1) = 1^3 + 1 = 1 + 1 = 2$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q025",
        questionNumber: 25,
        question: "若 $\\cos \\theta = \\frac{\\sqrt{2}}{2}$，則 $\\sin \\theta =$",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{\\sqrt{2}}{2}$" },
          { id: "C", text: "$\\frac{\\sqrt{3}}{2}$" },
          { id: "D", text: "$1$" }
        ],
        correctAnswer: "B",
        solution: "$\\sin^2 \\theta + \\cos^2 \\theta = 1$\\n$\\sin^2 \\theta = 1 - \\cos^2 \\theta = 1 - (\\frac{\\sqrt{2}}{2})^2 = 1 - \\frac{2}{4} = \\frac{2}{4} = \\frac{1}{2}$\\n$\\sin \\theta = \\frac{\\sqrt{2}}{2}$",
        topic: "三角函數",
        difficulty: "中等"
      },
      {
        id: "2019Q026",
        questionNumber: 26,
        question: "若 $\\tan \\theta = \\sqrt{3}$，則 $\\theta =$",
        options: [
          { id: "A", text: "$30°$" },
          { id: "B", text: "$45°$" },
          { id: "C", text: "$60°$" },
          { id: "D", text: "$90°$" }
        ],
        correctAnswer: "C",
        solution: "$\\tan \\theta = \\sqrt{3}$\\n$\\theta = 60°$",
        topic: "三角函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q027",
        questionNumber: 27,
        question: "若 $a = 7$，$b = 24$，則 $\\sqrt{a^2 + b^2} =$",
        options: [
          { id: "A", text: "$25$" },
          { id: "B", text: "$31$" },
          { id: "C", text: "$35$" },
          { id: "D", text: "$625$" }
        ],
        correctAnswer: "A",
        solution: "$\\sqrt{a^2 + b^2} = \\sqrt{7^2 + 24^2} = \\sqrt{49 + 576} = \\sqrt{625} = 25$",
        topic: "畢氏定理",
        difficulty: "基礎"
      },
      {
        id: "2019Q028",
        questionNumber: 28,
        question: "若 $x^2 - 10x + 25 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$5$" },
          { id: "B", text: "$-5$" },
          { id: "C", text: "$5$ 或 $-5$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 - 10x + 25 = (x-5)^2 = 0$\\n$x - 5 = 0$\\n$x = 5$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q029",
        questionNumber: 29,
        question: "若 $\\log_6 x = 2$，則 $x =$",
        options: [
          { id: "A", text: "$12$" },
          { id: "B", text: "$36$" },
          { id: "C", text: "$72$" },
          { id: "D", text: "$216$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_6 x = 2$\\n$x = 6^2 = 36$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q030",
        questionNumber: 30,
        question: "若 $f(x) = x^2 + 4x + 4$，則 $f(-2) =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$4$" },
          { id: "C", text: "$8$" },
          { id: "D", text: "$16$" }
        ],
        correctAnswer: "A",
        solution: "$f(-2) = (-2)^2 + 4(-2) + 4 = 4 - 8 + 4 = 0$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q031",
        questionNumber: 31,
        question: "若 $\\sin \\theta = \\frac{1}{\\sqrt{2}}$，則 $\\cos \\theta =$",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{1}{\\sqrt{2}}$" },
          { id: "C", text: "$\\frac{\\sqrt{2}}{2}$" },
          { id: "D", text: "$1$" }
        ],
        correctAnswer: "B",
        solution: "$\\sin^2 \\theta + \\cos^2 \\theta = 1$\\n$\\cos^2 \\theta = 1 - \\sin^2 \\theta = 1 - (\\frac{1}{\\sqrt{2}})^2 = 1 - \\frac{1}{2} = \\frac{1}{2}$\\n$\\cos \\theta = \\frac{1}{\\sqrt{2}}$",
        topic: "三角函數",
        difficulty: "中等"
      },
      {
        id: "2019Q032",
        questionNumber: 32,
        question: "若 $a = 8$，$b = 15$，則 $\\sqrt{a^2 + b^2} =$",
        options: [
          { id: "A", text: "$17$" },
          { id: "B", text: "$23$" },
          { id: "C", text: "$25$" },
          { id: "D", text: "$289$" }
        ],
        correctAnswer: "A",
        solution: "$\\sqrt{a^2 + b^2} = \\sqrt{8^2 + 15^2} = \\sqrt{64 + 225} = \\sqrt{289} = 17$",
        topic: "畢氏定理",
        difficulty: "基礎"
      },
      {
        id: "2019Q033",
        questionNumber: 33,
        question: "若 $x^2 + 12x + 36 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$-6$" },
          { id: "B", text: "$6$" },
          { id: "C", text: "$-6$ 或 $6$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 + 12x + 36 = (x+6)^2 = 0$\\n$x + 6 = 0$\\n$x = -6$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q034",
        questionNumber: 34,
        question: "若 $\\log_7 x = 3$，則 $x =$",
        options: [
          { id: "A", text: "$21$" },
          { id: "B", text: "$49$" },
          { id: "C", text: "$343$" },
          { id: "D", text: "$2401$" }
        ],
        correctAnswer: "C",
        solution: "$\\log_7 x = 3$\\n$x = 7^3 = 343$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q035",
        questionNumber: 35,
        question: "若 $f(x) = x^3 + 2x^2 + x$，則 $f(0) =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$1$" },
          { id: "C", text: "$2$" },
          { id: "D", text: "$3$" }
        ],
        correctAnswer: "A",
        solution: "$f(0) = 0^3 + 2(0)^2 + 0 = 0 + 0 + 0 = 0$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q036",
        questionNumber: 36,
        question: "若 $\\cos \\theta = \\frac{\\sqrt{3}}{2}$，則 $\\sin \\theta =$",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{\\sqrt{2}}{2}$" },
          { id: "C", text: "$\\frac{1}{\\sqrt{2}}$" },
          { id: "D", text: "$\\frac{\\sqrt{3}}{3}$" }
        ],
        correctAnswer: "A",
        solution: "$\\sin^2 \\theta + \\cos^2 \\theta = 1$\\n$\\sin^2 \\theta = 1 - \\cos^2 \\theta = 1 - (\\frac{\\sqrt{3}}{2})^2 = 1 - \\frac{3}{4} = \\frac{1}{4}$\\n$\\sin \\theta = \\frac{1}{2}$",
        topic: "三角函數",
        difficulty: "中等"
      },
      {
        id: "2019Q037",
        questionNumber: 37,
        question: "若 $a = 9$，$b = 40$，則 $\\sqrt{a^2 + b^2} =$",
        options: [
          { id: "A", text: "$41$" },
          { id: "B", text: "$49$" },
          { id: "C", text: "$50$" },
          { id: "D", text: "$1681$" }
        ],
        correctAnswer: "A",
        solution: "$\\sqrt{a^2 + b^2} = \\sqrt{9^2 + 40^2} = \\sqrt{81 + 1600} = \\sqrt{1681} = 41$",
        topic: "畢氏定理",
        difficulty: "基礎"
      },
      {
        id: "2019Q038",
        questionNumber: 38,
        question: "若 $x^2 - 14x + 49 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$7$" },
          { id: "B", text: "$-7$" },
          { id: "C", text: "$7$ 或 $-7$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 - 14x + 49 = (x-7)^2 = 0$\\n$x - 7 = 0$\\n$x = 7$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q039",
        questionNumber: 39,
        question: "若 $\\log_8 x = 2$，則 $x =$",
        options: [
          { id: "A", text: "$16$" },
          { id: "B", text: "$64$" },
          { id: "C", text: "$128$" },
          { id: "D", text: "$512$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_8 x = 2$\\n$x = 8^2 = 64$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q040",
        questionNumber: 40,
        question: "若 $f(x) = x^2 - 6x + 9$，則 $f(3) =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$9$" },
          { id: "C", text: "$18$" },
          { id: "D", text: "$27$" }
        ],
        correctAnswer: "A",
        solution: "$f(3) = 3^2 - 6(3) + 9 = 9 - 18 + 9 = 0$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q041",
        questionNumber: 41,
        question: "若 $\\tan \\theta = \\frac{1}{\\sqrt{3}}$，則 $\\theta =$",
        options: [
          { id: "A", text: "$30°$" },
          { id: "B", text: "$45°$" },
          { id: "C", text: "$60°$" },
          { id: "D", text: "$90°$" }
        ],
        correctAnswer: "A",
        solution: "$\\tan \\theta = \\frac{1}{\\sqrt{3}}$\\n$\\theta = 30°$",
        topic: "三角函數",
        difficulty: "基礎"
      },
      {
        id: "2019Q042",
        questionNumber: 42,
        question: "若 $a = 10$，$b = 24$，則 $\\sqrt{a^2 + b^2} =$",
        options: [
          { id: "A", text: "$26$" },
          { id: "B", text: "$34$" },
          { id: "C", text: "$40$" },
          { id: "D", text: "$676$" }
        ],
        correctAnswer: "A",
        solution: "$\\sqrt{a^2 + b^2} = \\sqrt{10^2 + 24^2} = \\sqrt{100 + 576} = \\sqrt{676} = 26$",
        topic: "畢氏定理",
        difficulty: "基礎"
      },
      {
        id: "2019Q043",
        questionNumber: 43,
        question: "若 $x^2 + 16x + 64 = 0$，則 $x =$",
        options: [
          { id: "A", text: "$-8$" },
          { id: "B", text: "$8$" },
          { id: "C", text: "$-8$ 或 $8$" },
          { id: "D", text: "無實數解" }
        ],
        correctAnswer: "A",
        solution: "$x^2 + 16x + 64 = (x+8)^2 = 0$\\n$x + 8 = 0$\\n$x = -8$",
        topic: "二次方程",
        difficulty: "基礎"
      },
      {
        id: "2019Q044",
        questionNumber: 44,
        question: "若 $\\log_9 x = 2$，則 $x =$",
        options: [
          { id: "A", text: "$18$" },
          { id: "B", text: "$81$" },
          { id: "C", text: "$162$" },
          { id: "D", text: "$729$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_9 x = 2$\\n$x = 9^2 = 81$",
        topic: "對數",
        difficulty: "基礎"
      },
      {
        id: "2019Q045",
        questionNumber: 45,
        question: "若 $f(x) = x^2 + 8x + 16$，則 $f(-4) =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$16$" },
          { id: "C", text: "$32$" },
          { id: "D", text: "$64$" }
        ],
        correctAnswer: "A",
        solution: "$f(-4) = (-4)^2 + 8(-4) + 16 = 16 - 32 + 16 = 0$",
        topic: "函數",
        difficulty: "基礎"
      }
    ],
    topics: ["三角函數", "畢氏定理", "二次方程", "對數", "函數"],
    statistics: {
      totalAttempts: 0,
      correctAttempts: 0,
      averageScore: 0,
      completionRate: 0
    }
  };